import React from 'react'
import Addpartlist from './addpartlist'
import { Iprops } from './addpartlistinterface'


function addpartlistcontainer(props: Iprops) {
    return (
        <Addpartlist getBookmarkItems={props.getBookmarkItems}
            getPartsListItemsForGrid={props.getPartsListItemsForGrid}  addtoListOnClick={props.addtoListOnClick} partsListItems={props.partsListItems} selectedBookmarkItem={props.selectedBookmarkItem} />
  )
}

export default addpartlistcontainer